import { inCommands } from '../../../concepts/commands/CommandRegistry';
import { inTool } from '../../canvas/tooling/ToolManager';
import { Package, PackageHost } from '../../Container';
import { inExportAdapter } from '../dataExport/ExportAdapter';
import { createZone, selectionApplyZones } from './ZoneCommands';
import { StickyInZoneExportAdapter } from './ZoneExports';
import { ZoneIndex } from './ZoneIndex';
import { ZoneMechanics } from './ZoneMechanics';
import { ZonePeerMechanics } from './ZonePeerMechanics';
import { zoneTool } from './ZoneTool';

export class ZonePackage implements Package {

    public install = (host: PackageHost) => host
        .register(ZoneIndex, 'singleton', 'startable')
        .register(ZoneMechanics, 'singleton', 'startable')
        .register(ZonePeerMechanics, 'singleton', 'startable')
        .plug(inCommands(createZone, selectionApplyZones))
        .plug(inTool(zoneTool))
        // .plug(inToolboxItems(zoneToolboxItem))
        .plug(inExportAdapter(StickyInZoneExportAdapter))
        // .plug(inExportAdapter(TaskCardInZoneExportAdapter))

        ;
}
